import React, { useCallback, useState } from "react";
import { BiExport } from "react-icons/bi";
import { FaTimesCircle } from "react-icons/fa";
import SurveySummary from "./SurveySummary";
import List from "./List";
import { CiSearch } from "react-icons/ci";
import {
  fetchSurveyResponsesForExport,
  type SurveyResponse,
} from "./fetchSurveyResponsesExport";
import { buildSurveyResponsesCsv } from "./surveyResponsesTable";
import RangeExportModal from "../../../components/admin-export/RangeExportModal";
import type { IsoDateRange } from "../../../lib/adminExport/datePresets";

const SurveyReport = ({ setShowSurvey }: any) => {
  const [status, setStatus] = useState<string>("Summary");
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [exportOpen, setExportOpen] = useState(false);

  const fetchRows = useCallback(
    (range: IsoDateRange | null) =>
      fetchSurveyResponsesForExport(range, searchTerm),
    [searchTerm]
  );

  return (
    <div className="font-manrope w-full h-full">
      <div className="flex justify-between items-center">
        <h2 className="font-bold  font-sora text-[24px] text-white">{}</h2>
        <FaTimesCircle
          onClick={() => {
            setShowSurvey(false);
          }}
          className="text-[#78C2F7] text-[24px] cursor-pointer"
        />
      </div>
      <div className="w-full flex justify-between items-center mt-10">
        <h4 className="text-white uppercase font-sora font-semibold text-[10px]">
          Survey
        </h4>
        {status === "List" && (
          <button
            type="button"
            onClick={() => setExportOpen(true)}
            className="flex items-center justify-center gap-2"
          >
            <BiExport className="text-[white]" />
            <h4 className="uppercase font-sora font-semibold mt-1 text-[#869AA9] text-[10px]">
              Export
            </h4>
          </button>
        )}
      </div>
      <div className="w-full pr-8 bg-[#0D0D0D] mt-4 h-[67px] flex justify-between items-center">
        <div className="h-full flex justify-start items-center">
          <button
            onClick={() => setStatus("Summary")}
            className={
              status === "Summary"
                ? "h-full border-b-2  font-bold  text-[16px] text-secondary_button border-secondary_button px-4"
                : "h-full   text-[14px] text-gray-200 px-4"
            }
          >
            Summary
          </button>
          <button
            onClick={() => setStatus("List")}
            className={
              status === "List"
                ? "h-full border-b-2  font-bold  text-[16px] text-secondary_button border-secondary_button px-4"
                : "h-full   text-[14px] text-gray-200 px-4"
            }
          >
            List
          </button>
        </div>
        <div className=" w-1/5  px-3 py-3 gap-2 rounded-xl bg-[#191919] flex justify-start items-center">
          <CiSearch className="text-[24px] text-gray-50 " />
          <input
            type="search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-11/12  text-gray-200 bg-transparent outline-none text-[14px]"
            placeholder="Search"
          />
        </div>
      </div>
      {status === "Summary" ? (
        <SurveySummary />
      ) : status === "List" ? (
        <List searchTerm={searchTerm} />
      ) : null}
      <RangeExportModal
        open={exportOpen}
        onClose={() => setExportOpen(false)}
        title="Survey responses"
        fileBasename="survey-list"
        fetchRows={fetchRows}
        buildCsv={(rows) => buildSurveyResponsesCsv(rows as SurveyResponse[])}
      />
    </div>
  );
};

export default SurveyReport;
